/*
 * This function need to correct represent count of likes for product.
 *
 * After click to the "like" button we need some time to calculate correct
 * count of likes for current product. So after user click to "like" button and
 * after reload of page he can to see 0. So this function fix wrong behavior.
 * @param count count of likes for product
 * @param isLiked is this product liked by current user
 */
export const prepareFavouriteCount = (
  count: number,
  isLiked = false,
): number => {
  if (count > 0) {
    return count;
  }

  if (isLiked) {
    return 1;
  }

  return 0;
};
